<!--
@Time : 2020/11/26 5:59 下午
@Author : yekong
@File : tabx.vue
@Software : PhpStorm
-->
<template>
  <div class="paimingx">
    <div class="paiming" :class="{active:active==0}" @click="getactive(0)">
      <div class="bg"></div>
      <div class="title">
        环节监控
      </div>
      <div class="line"></div>
    </div>
    <div class="paiming" :class="{active:active==1}" @click="getactive(1)">
      <div class="bg"></div>
      <div class="title">
        耗时分析
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabx",
  data: function () {
    return {
      active: 0
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    getactive(e) {
      this.active = e;
      this.$emit('getactive', e)
    }
  },
  mounted() {
    this.$emit('getactive', 0)
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paimingx {
  @include flex_start_center();
  height: 145px;

}

.paiming {
  position: relative;
  margin-right: 140px;
  cursor: pointer;

  .title {
    font-size: 60px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.6);
    height: 75px;
    position: relative;
    @include flex_start_center();
    padding-left: 30px;
  }

  .line {
    width: 214px;
    height: 11px;
    background: none;
    position: absolute;
    bottom: 0;
    left: 55px;
  }

  .bg {
    position: absolute;
    left: 0;
    width: 148px;
    height: 75px;
    top: 0;
    background: none;
  }
}

.paiming.active {
  position: relative;

  .title {
    font-size: 60px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    height: 75px;
    position: relative;
    @include flex_start_center();
    padding-left: 30px;
  }

  .line {
    width: 214px;
    height: 11px;
    background: #47CAE9;
    position: absolute;
    bottom: 0;
    left: 55px;
  }

  .bg {
    position: absolute;
    left: 0;
    width: 148px;
    height: 75px;
    top: 0;
    background: #479BAF;
  }
}
</style>
